import { apiRequest } from './http';
import type {
  ApiItemResponse,
  As2DlqListQuery,
  As2DlqTaskRecord,
} from '../types/api';

function queryString(query: As2DlqListQuery): string {
  const search = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (value !== undefined && value !== '') {
      search.set(key, String(value));
    }
  });

  const serialized = search.toString();
  return serialized ? `?${serialized}` : '';
}

// The AS2 gateway paginates with Spring-style `{ content, totalElements }` envelopes
// (not this app's usual `{ data, total, page, pageSize }` shape), so the list call below
// normalizes it into the app's standard list-result shape for reuse with the existing
// list/pagination UI conventions.
interface GatewayPage<T> {
  content: T[];
  totalElements: number;
}

export interface As2DlqListResult {
  data: As2DlqTaskRecord[];
  total: number;
  page: number;
  pageSize: number;
}

export async function listAs2DlqTasks(query: As2DlqListQuery): Promise<As2DlqListResult> {
  const response = await apiRequest<ApiItemResponse<GatewayPage<As2DlqTaskRecord>>>(`/as2/dlq${queryString(query)}`);
  return {
    data: response.data.content,
    total: response.data.totalElements,
    page: query.page ?? 0,
    pageSize: query.size ?? 20,
  };
}

export async function getAs2DlqTask(id: string): Promise<As2DlqTaskRecord> {
  return (await apiRequest<ApiItemResponse<As2DlqTaskRecord>>(`/as2/dlq/${id}`)).data;
}

export async function requeueAs2DlqTask(
  id: string,
  payload: { reason: string; resetRetryCount?: boolean },
): Promise<As2DlqTaskRecord> {
  return (await apiRequest<ApiItemResponse<As2DlqTaskRecord>>(`/as2/dlq/${id}/requeue`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })).data;
}

export async function discardAs2DlqTask(id: string, payload: { reason: string }): Promise<As2DlqTaskRecord> {
  return (await apiRequest<ApiItemResponse<As2DlqTaskRecord>>(`/as2/dlq/${id}/discard`, {
    method: 'POST',
    body: JSON.stringify(payload),
  })).data;
}
